import {CustomLayoutSection} from './custom-layout-section.model';

export class CustomLayout {
  Id: number;
  Name: string;
  Description: string = '';
  LayoutTypeID: number;
  Scope: string;
  SelectedSites: string;
  Owner: number;
  OwnerName: string;
  AddedOn: Date;
  AddedBy: number;
  LastUpOn: Date;
  LastUpBy: number;
  DelStatus: boolean;
  DelOn: Date;
  DelBy: number;
  TylerDefault: boolean;
  Sections: CustomLayoutSection[] = [];
  ErrorMessage = '';
}